import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick", "className"];
import { forwardRef } from 'react';
import useUsageTracker from '../hooks/useUsageTracker';
import { filterToDOMAttributes } from 'unified-navigation-ui/utils/filterToDOMAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackedLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      onClick,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackNavClick
  } = useUsageTracker();
  const trackedOnClick = evt => {
    trackNavClick(evt);
    if (onClick) {
      return onClick(evt);
    }
    return undefined;
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _jsx("a", Object.assign({
      className: className,
      onClick: trackedOnClick,
      ref: ref
    }, filterToDOMAttributes(rest), {
      children: children
    }))
  );
});
TrackedLink.displayName = 'TrackedLink';
export default TrackedLink;